export function useDelayedPending(status: Ref, delay = 500) {
  const showPending = ref(false)
  let timer: ReturnType<typeof setTimeout>
  const clearTimer = () => {
    clearTimeout(timer)
    showPending.value = false
  }

  watch(
    () => status.value === 'pending',
    (isPending) => {
      if (isPending) {
        clearTimer()
        timer = setTimeout(() => {
          showPending.value = true
        }, delay)
      } else {
        clearTimer()
      }
    }
  )

  onUnmounted(() => {
    if (timer) {
      clearTimeout(timer)
    }
  })

  return showPending
}
